"use strict";
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenExchangeRequest = exports.TokenStatus = exports.AadResourceUrls = exports.ErrorResponse = exports.ErrorModel = exports.InnerHttpError = exports.TokenResponse = exports.SignInUrlResponse = exports.TokenExchangeResource = void 0;
exports.TokenExchangeResource = {
    serializedName: "TokenExchangeResource",
    type: {
        name: "Composite",
        className: "TokenExchangeResource",
        modelProperties: {
            id: {
                serializedName: "id",
                type: {
                    name: "String"
                }
            },
            uri: {
                serializedName: "uri",
                type: {
                    name: "String"
                }
            },
            providerId: {
                serializedName: "providerId",
                type: {
                    name: "String"
                }
            }
        }
    }
};
exports.SignInUrlResponse = {
    serializedName: "SignInUrlResponse",
    type: {
        name: "Composite",
        className: "SignInUrlResponse",
        modelProperties: {
            signInLink: {
                serializedName: "signInLink",
                type: {
                    name: "String"
                }
            },
            tokenExchangeResource: {
                serializedName: "tokenExchangeResource",
                type: {
                    name: "Composite",
                    className: "TokenExchangeResource"
                }
            }
        }
    }
};
exports.TokenResponse = {
    serializedName: "TokenResponse",
    type: {
        name: "Composite",
        className: "TokenResponse",
        modelProperties: {
            channelId: {
                serializedName: "channelId",
                type: {
                    name: "String"
                }
            },
            connectionName: {
                serializedName: "connectionName",
                type: {
                    name: "String"
                }
            },
            token: {
                serializedName: "token",
                type: {
                    name: "String"
                }
            },
            expiration: {
                serializedName: "expiration",
                type: {
                    name: "String"
                }
            }
        }
    }
};
exports.InnerHttpError = {
    serializedName: "InnerHttpError",
    type: {
        name: "Composite",
        className: "InnerHttpError",
        modelProperties: {
            statusCode: {
                serializedName: "statusCode",
                type: {
                    name: "Number"
                }
            },
            body: {
                serializedName: "body",
                type: {
                    name: "Object"
                }
            }
        }
    }
};
exports.ErrorModel = {
    serializedName: "Error",
    type: {
        name: "Composite",
        className: "ErrorModel",
        modelProperties: {
            code: {
                serializedName: "code",
                type: {
                    name: "String"
                }
            },
            message: {
                serializedName: "message",
                type: {
                    name: "String"
                }
            },
            innerHttpError: {
                serializedName: "innerHttpError",
                type: {
                    name: "Composite",
                    className: "InnerHttpError"
                }
            }
        }
    }
};
exports.ErrorResponse = {
    serializedName: "ErrorResponse",
    type: {
        name: "Composite",
        className: "ErrorResponse",
        modelProperties: {
            error: {
                serializedName: "error",
                type: {
                    name: "Composite",
                    className: "ErrorModel"
                }
            }
        }
    }
};
exports.AadResourceUrls = {
    serializedName: "AadResourceUrls",
    type: {
        name: "Composite",
        className: "AadResourceUrls",
        modelProperties: {
            resourceUrls: {
                serializedName: "resourceUrls",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "String"
                        }
                    }
                }
            }
        }
    }
};
exports.TokenStatus = {
    serializedName: "TokenStatus",
    type: {
        name: "Composite",
        className: "TokenStatus",
        modelProperties: {
            channelId: {
                serializedName: "channelId",
                type: {
                    name: "String"
                }
            },
            connectionName: {
                serializedName: "connectionName",
                type: {
                    name: "String"
                }
            },
            hasToken: {
                serializedName: "hasToken",
                type: {
                    name: "Boolean"
                }
            },
            serviceProviderDisplayName: {
                serializedName: "serviceProviderDisplayName",
                type: {
                    name: "String"
                }
            }
        }
    }
};
exports.TokenExchangeRequest = {
    serializedName: "TokenExchangeRequest",
    type: {
        name: "Composite",
        className: "TokenExchangeRequest",
        modelProperties: {
            uri: {
                serializedName: "uri",
                type: {
                    name: "String"
                }
            },
            token: {
                serializedName: "token",
                type: {
                    name: "String"
                }
            }
        }
    }
};
//# sourceMappingURL=mappers.js.map